<!-- Tabs showing which snippets for contact info are displayed in the ContactTabView.
-->

<template>
  <mdb-row>
    <mdb-col v-if="contact_info.length > 1" lg="3" class="my-3">
      <mdb-btn-group vertical class="btn-block">
        <mdb-btn
          class="text-left btn-block"
          color="primary"
          v-for="tab in contact_info"
          :key="tab.id"
          action
          :class="{ active: tab === selectedTab}"
          @click.native="updateTabSelection(tab)"
          ><strong>{{tab.contact_name}}</strong>
        </mdb-btn>
      </mdb-btn-group>
    </mdb-col>
    <mdb-col>
      <ContactTabView  
        :contact_info="selectedTab">
      </ContactTabView>
    </mdb-col>
  </mdb-row>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbBtnGroup
} from "mdbvue";
import ContactTabView from "@/views/contact/ContactTabView.vue";
export default {
  name: "ContactTab",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbBtnGroup,
    ContactTabView
  },
  props: {
    contact_info: Array
  },
  data() {
    return {
      loading: true,
      tabs: false,
      selectedTab: false,
    };
  },
  mounted() {
    if (!this.selectedTab) {
      this.selectedTab = this.contact_info[0];
    }
  },
  methods: {
    updateTabSelection(tab) {
      this.selectedTab = tab;
    },
  }
}
</script>